<template>
	<div class="tab">
		<div
			class="tab-item"
			:class="selectedTab == 'offers' ? 'active' : ''"
			@click="handleTab('offers')"
		>
			<span>Ofertas</span>
		</div>
		<div
			class="tab-item"
			:class="selectedTab == 'users' ? 'active' : ''"
			@click="handleTab('users')"
		>
			<span>Usuários</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OriginatorTab',
	data: () => ({
		selectedTab: 'offers',
	}),
	methods: {
		handleTab(param) {
			this.selectedTab = param;
			this.$emit('handleTab', param);
		},
	},
};
</script>

<style lang="scss">
@import 'OriginatorTab.scss';
</style>
